<template>
  <div>
    <div class="container animated bounceInRight" v-if="research">
      <h3 class="centered">{{ research.name }}</h3>
      <!-- Text -->
      <div class="container">
        <div class="row">
          <div
            class="col-md-12 text-justify"
            v-if="research.presentation_text"
            v-html="research.presentation_text"
          ></div>
          <div class="col-md-12" v-if="!research.presentation_text">
            <p class="text-title">Prezado(a) colaborador(a)</p>
            <p class="text">
              Você foi selecionado(a) para participar da pesquisa de clima de
              trabalho e poderá opinar sobre o ambiente de trabalho da sua
              empresa. Preencha o formulário de forma sincera e honesta.
            </p>
            <p class="text">
              O sigilo e anonimato são garantidos, e suas respostas serão
              enviadas diretamente ao RH e ninguém de fora terá acesso às
              respostas.
            </p>
            <p class="text">
              Para cada afirmativa existem 5 opções de respostas e você deve
              assinalar somente uma. Caso você não queira ou não saiba responder
              uma afirmativa, deixe-a no "0", e ela não será contada.
            </p>
            <p class="text">
              Leia todas as afirmativas abaixo e marque uma única resposta para
              cada coluna. Considere suas respostas sob dois pontos de vista:
              Visão Departamento e Visão Empresa.
            </p>
            <p class="text">
              <span>Visão Departamento:</span>Corresponde à área na qual você
              trabalha, às pessoas que são mais próximas no seu dia a dia e que
              fazem parte de sua equipe.
            </p>
            <p class="text">
              <span>Visão Empresa:</span>Refere-se à sua empresa como um todo.
            </p>
            <p class="text">
              Com relação as informações demográficas, precisamos das mesmas
              para classificar os participantes em categorias distintas. Por
              favor, selecione os itens que correspondem à sua situação na
              empresa.
            </p>
            <p class="text">
              <span
                >Esta classificação não tem o intuito de identificar quem
                respondeu</span
              >, mas é extremamente importante que você a faça corretamente de
              acordo com suas informações para uma correta visualização dos
              resultados da empresa. Uma classificação errada, poderá distorcer
              o resultado impossibilitando futuras ações.
            </p>
          </div>
        </div>
      </div>

      <div v-if="research.anonymity_level == 3" class="mb-5 mt-4">
        <div class="container-fluid title">
          <div class="row">
            <div class="col-12">
              <h1>Modo anônimo</h1>
            </div>
          </div>
        </div>
        <p>Deseja manter as suas respostas anônimas?</p>
        <div class="row">
          <div class="col-6">
            <button
              :class="[
                'btn-block btn-normal',
                { active: chosen_anonymous_answer === false },
              ]"
              @click="chosen_anonymous_answer = false"
            >
              Não
            </button>
          </div>
          <div class="col-6">
            <button
              :class="[
                'btn-block btn-normal',
                { active: chosen_anonymous_answer === true },
              ]"
              @click="chosen_anonymous_answer = true"
            >
              Sim
            </button>
          </div>
        </div>
      </div>
      <hr />

      <div v-for="(askGroup, index) in researchAsksGrouped" :key="index">
        <div v-if="index == 2 && askGroup.length">
          <!-- Infos -->
          <div class="container infos">
            <div class="alert alert-danger mt-4 py-4" role="alert">
              <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
              <strong>
                Leia atentamente a questão e responda avaliando a Visão
                Departamento e a Visão Empresa sendo:</strong
              >
            </div>
            <div class="row">
              <div class="col-md-2 info text-left">
                <span>0 -</span>{{ research["scale-label-0"] }}
              </div>
              <div class="col-md-2 info text-left">
                <span>1 -</span>{{ research["scale-label-1"] }}
              </div>
              <div class="col-md-2 info text-left">
                <span>2 -</span>{{ research["scale-label-2"] }}
              </div>
              <div class="col-md-2 info text-left">
                <span>3 -</span>{{ research["scale-label-3"] }}
              </div>
              <div class="col-md-2 info text-left">
                <span>4 -</span>{{ research["scale-label-4"] }}
              </div>
            </div>
          </div>

          <!-- Section Scale -->
          <section id="questionScale">
            <div class="container">
              <div class="row descriptions">
                <div class="col-md-6">
                  <p class="description">Afirmações</p>
                </div>
                <div class="col-md-3">
                  <p class="description">Visão Departamento</p>
                </div>
                <div class="col-md-3">
                  <p class="description">Visão Empresa</p>
                </div>
              </div>
              <div class="row questions" v-for="ask in askGroup" :key="ask.id">
                <div class="col-md-6">
                  <p class="question">
                    <span>
                      {{ ask.idx }} )
                      {{ ask.title }}
                    </span>
                  </p>
                </div>
                <div class="col-md-3">
                  <p class="desc-small">
                    <i class="fas fa-level-up-alt"></i>Visão Departamento
                  </p>
                  <input
                    type="range"
                    class="custom-range"
                    min="0"
                    max="4"
                    v-model="ask.department"
                    step="1"
                  />
                  <input
                    type="text"
                    class="value-range"
                    :value="ask.department"
                    readonly
                  />
                </div>
                <div class="col-md-3">
                  <p class="desc-small">
                    <i class="fas fa-level-up-alt"></i>Visão Empresa
                  </p>
                  <input
                    type="range"
                    class="custom-range"
                    min="0"
                    max="4"
                    v-model="ask.company"
                    step="1"
                  />
                  <input
                    type="text"
                    class="value-range"
                    :value="ask.company"
                    readonly
                  />
                </div>
              </div>
            </div>
          </section>
        </div>
        <div v-if="index == 1 && askGroup.length">
          <!-- Section Choice -->
          <section id="questionChoice">
            <div class="container">
              <div
                class="row questions pb-2"
                v-for="ask in askGroup"
                :key="ask.id"
              >
                <div class="col-md-12">
                  <p class="question">
                    <span>
                      {{ ask.idx }} )
                      {{ ask.title }}
                    </span>
                  </p>
                </div>
                <div class="col-md-12">
                  <div
                    class="custom-control custom-radio"
                    v-for="option in ask.options"
                    :key="option.id"
                    @click="optionClicked(ask, option)"
                  >
                    <input
                      type="radio"
                      class="custom-control-input"
                      :value="option.id"
                      v-model="ask.answer"
                      :name="'answers-radio-' + ask.id"
                    />
                    <label class="custom-control-label">{{
                      option.description
                    }}</label>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
        <div v-if="index == 4 && askGroup.length">
          <!-- Section Text -->
          <section id="questionText">
            <div class="container">
              <div class="row" v-for="ask in askGroup" :key="ask.id">
                <div class="col-md-12">
                  <p class="question">
                    <span>
                      {{ ask.idx }} )
                      {{ ask.title }}
                    </span>
                  </p>
                  <textarea
                    class="form-control"
                    rows="3"
                    v-model="ask.answer"
                  ></textarea>
                </div>
              </div>
            </div>
          </section>
        </div>

        <div v-if="index == 3 && askGroup.length">
          <!-- Section Scale -->
          <section id="questionRanking">
            <div class="alert alert-danger mt-4 py-4" role="alert">
              <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
              <strong>
                Para responder à questão abaixo, clique na opção desejada e
                arraste com o mouse de acordo com a sua preferência.</strong
              >
            </div>
            <div class="container">
              <div class="row questions" v-for="ask in askGroup" :key="ask.id">
                <div class="col-md-6">
                  <p class="question">
                    <span>
                      {{ ask.idx }} )
                      {{ ask.title }}
                    </span>
                  </p>
                  <draggable v-model="ask.options">
                    <transition-group>
                      <div
                        v-for="(option, index) in ask.options"
                        :key="option.id"
                      >
                        <div class="container">
                          <div class="row">
                            <div class="col-2">
                              <span
                                ><strong>{{ index }}</strong></span
                              >
                            </div>
                            <div class="col">
                              <input
                                :keyup.down="update(ask.id, option.id, index)"
                                class="form-control"
                                type="text"
                                v-model="option.description"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </transition-group> </draggable
                  ><br />
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
      <button class="btn btn-normal btn-block mt-5" @click.once="save">
        Enviar respostas
      </button>
    </div>
  </div>
</template>

<script>
import Draggable from "vuedraggable";

export default {
  components: { Draggable },
  data() {
    return {
      research: null,
      chosen_anonymous_answer: "",
    };
  },
  computed: {
    researchAsksGrouped() {
      const self = this;
      let researchAsksGrouped = {
        1: [],
        2: [],
        3: [],
        4: [],
      };
      self.research.asks.forEach((ask) => {
        researchAsksGrouped[ask.type_id].push(ask);
      });

      let newOrder = [];

      newOrder[1] = researchAsksGrouped[2];
      newOrder[2] = researchAsksGrouped[1];
      newOrder[3] = researchAsksGrouped[4];
      newOrder[4] = researchAsksGrouped[3];

      researchAsksGrouped = newOrder;

      let idx = 1;
      let g1 = [];
      researchAsksGrouped[1].forEach((ask) => {
        ask.idx = idx;
        g1.push(ask);
        idx = idx + 1;
      });

      researchAsksGrouped[1] = g1;

      let g2 = [];
      researchAsksGrouped[2].forEach((ask) => {
        ask.idx = idx;
        g2.push(ask);
        idx = idx + 1;
      });

      researchAsksGrouped[2] = g2;

      let g3 = [];
      researchAsksGrouped[3].forEach((ask) => {
        ask.idx = idx;
        g3.push(ask);
        idx = idx + 1;
      });

      researchAsksGrouped[3] = g3;

      let g4 = [];
      researchAsksGrouped[4].forEach((ask) => {
        ask.idx = idx;
        g4.push(ask);
        idx = idx + 1;
      });

      researchAsksGrouped[4] = g4;

      return researchAsksGrouped;
    },
  },
  methods: {
    update(askId, optionId, index) {
      this.research.asks.forEach((ask) => {
        ask.options.forEach((elem) => {
          if (elem.ask_id == askId && elem.id == optionId) {
            elem.optionChose = index;
          }
        });
      });
    },

    optionClicked(ask, option) {
      ask.answer = option.id;
    },
    getResearch() {
      const self = this;
      const api =
        self.$store.state.api +
        "researches?id=" +
        self.$route.params.id +
        "&with[]=asks.options";
      self.$http
        .get(api)
        .then((response) => {
          let research = response.data.data[0];
          research.asks.forEach((ask) => {
            if (ask.type_id == 1) {
              ask.department = 0;
              ask.company = 0;
            } else if (ask.type_id == 2) {
              ask.answer = null;
            }
          });
          self.research = research;
        })
        .catch((error) => {
          self.$message("Erro", error.response.data, "error");
        });
    },
    save() {
      const self = this;
      const api = self.$store.state.api + "researchanswers";
      const fd = self.makeFormData();

      self.$http
        .post(api, fd)
        .then((response) => {
          self.$message("Sucesso", "Respostas enviadas com sucesso", "success");
          self.$router.push("/");
        })
        .catch((error) => {
          self.$message("Erro", error.response.data, "error");
        });
    },
    makeFormData() {
      const self = this;
      const fd = new FormData();

      let chosen_anonymous_answer = "";
      if (self.chosen_anonymous_answer === true) {
        chosen_anonymous_answer = 1;
      } else if (self.chosen_anonymous_answer === false) {
        chosen_anonymous_answer = 0;
      }
      fd.append("chosen_anonymous_answer", chosen_anonymous_answer);

      self.research.asks.forEach((ask) => {
        if (ask.type_id == 1) {
          fd.append("answers[" + ask.id + "][company]", ask.company);
          fd.append("answers[" + ask.id + "][department]", ask.department);
        } else if (ask.type_id == 2) {
          fd.append(
            "answers[" + ask.id + "][option_id]",
            ask.answer ? ask.answer : ""
          );
        } else if (ask.type_id == 3) {
          fd.append(
            "answers[" + ask.id + "][answer]",
            ask.answer ? ask.answer : ""
          );
        } else if (ask.type_id == 4) {
          fd.append(
            "answers[" + ask.id + "][answer]",
            ask.options ? JSON.stringify(ask.options) : ""
          );
        }
        fd.append("answers[" + ask.id + "][typeId]", ask.type_id);
      });

      fd.append("researchId", self.research.id);

      return fd;
    },
  },
  mounted: function () {
    const self = this;
    self.getResearch();
  },
};
</script>


// WEBPACK FOOTER //
// src/components/Main/Research.vue